import {getCookie} from '../../utils/cookies'
import {lastVisitTimestampConfig} from './cookieConfig'

export const getLastVisitTimestamp = () =>
  getCookie(lastVisitTimestampConfig.name)
